export default __webpack_public_path__ + "static/notifications-presentation-1f6e480e552f4243c0ee19c4cffce8e0.png";